import common from '@/i18n/en/common.js';
import nav from '@/i18n/en/nav.js';
import auth from '@/i18n/en/auth.js';
import settings from '@/i18n/en/settings.js';
import start from '@/i18n/en/start.js';
import tools from '@/i18n/en/tools.js';
import planner from '@/i18n/en/planner.js';
import entry from '@/i18n/en/entry.js';
import food from '@/i18n/en/food.js';
import forma from '@/i18n/en/forma.js';
import shopping from '@/i18n/en/shopping.js';
import basket from '@/i18n/en/basket.js';
import finance from '@/i18n/en/finance.js';
import wallet from '@/i18n/en/wallet.js';
import projects from '@/i18n/en/projects.js';
import notes from '@/i18n/en/notes.js';
import places from '@/i18n/en/places.js';
import assistant from '@/i18n/en/assistant.js';
import people from '@/i18n/en/people.js';
import pets from '@/i18n/en/pets.js';
import devices from '@/i18n/en/devices.js';
import cares from '@/i18n/en/cares.js';
import habits from '@/i18n/en/habits.js';
import medications from '@/i18n/en/medications.js';
import admin from '@/i18n/en/admin.js';

export default { admin, assistant, common, nav, auth, settings, start, tools, planner, entry, food, forma, shopping, basket, finance, wallet, projects, notes, places, people, pets, devices, cares, habits, medications };
